const BuildingPermit = () => {
  return <div>Building Permit</div>;
};

export default BuildingPermit;
